import { z } from 'zod';
import { uuidPattern } from './regex';
const UUIDValidationSchema = z.string().regex(uuidPattern, 'not a valid id');
const RequestIDValidationSchema = z.object({
    id: UUIDValidationSchema
});
export { RequestIDValidationSchema, UUIDValidationSchema };
//# sourceMappingURL=uuid.js.map